import { createQueryParams } from '@/utils/query-params';
import { api } from './index';

export interface ShiftVersionChange {
  field: string;
  fieldLabel: string;
  oldValue: string | null;
  newValue: string | null;
}

export interface ShiftVersion {
  id: number;
  event: 'create' | 'update' | 'destroy';
  createdAt: string;
  whodunnitLabel: string | null;
  changes: ShiftVersionChange[];
}

export interface DeletedShiftData {
  patientName: string;
  caregiverName: string;
  startDatetime: string;
  endDatetime: string;
  humanDate: string;
  humanTime: string;
  price?: number;
  caregiverCost?: number;
  withTaxBill?: boolean;
}

export interface DeletedShift {
  id: number;
  deletedAt: string;
  deletedBy: string | null;
  shiftData: DeletedShiftData;
}

const BASE_PATH = '/api/internal';

export const shiftVersionsApi = {
  index(shiftId: number): Promise<ShiftVersion[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/shifts/${shiftId}/versions`,
    }).then(response => response.data.versions);
  },
};

export interface DeletedShiftsParams {
  patientId?: number;
  caregiverId?: number;
  startDate: string;
  endDate: string;
}

export const deletedShiftsApi = {
  index(params: DeletedShiftsParams): Promise<DeletedShift[]> {
    const queryParams = createQueryParams(params);
    return api({
      method: 'get',
      url: `${BASE_PATH}/deleted_shifts?${queryParams}`,
    }).then(response => response.data.deletedShifts);
  },
};
